import BaseComponent from './BaseComponent';

class FactBoxExpandable extends BaseComponent {
    constructor(el) {
        super(el);

        el.querySelectorAll('.multi-teaser__title button').forEach((icon) => {
            icon.addEventListener('click', (e) => {
                e.preventDefault();
                let content = e.target.closest('.multi-teaser').querySelector('.multi-teaser__content');
                if (icon.classList.contains('multi-teaser__title__icon--open')) {
                    content.classList.remove('multi-teaser__content--open');
                    icon.classList.remove('multi-teaser__title__icon--open');
                    return;
                }
                content.classList.add('multi-teaser__content--open');
                icon.classList.add('multi-teaser__title__icon--open');
            });
        });
    }
}

export default FactBoxExpandable;
